import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductBundle } from '../components/ProductBundle';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FaqSection } from '../components/FaqSection';
import { PricingCta } from '../components/PricingCta';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0a0e1a] text-white selection:bg-[#00d4aa] selection:text-black" data-id="element-216">
      <HeroSection data-id="element-217" />
      <ProblemSection data-id="element-218" />
      <MechanismSection data-id="element-219" />
      <ProductBundle data-id="element-220" />
      <AudienceSection data-id="element-221" />
      <HowItWorks data-id="element-222" />
      <ProofSection data-id="element-223" />
      <FaqSection data-id="element-224" />
      <PricingCta data-id="element-225" />

      <Footer data-id="element-226" />
    </div>;
}